import React, { useState } from "react";
import "./Register.css";
import { db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import warning from "../img/redAlert.png";
import insta from "../img/insta.png";
import facebook from "../img/facebook.png";
import mail from "../img/mail.png";

const options = ["Deliberative Debate Council (DDC)"];

function generateTicket() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let code = "";
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return `UNISF-${code}`;
}

function Register() {
  const [selectedOption, setSelectedOption] = useState("");
  const [fields, setFields] = useState({
    fullName: "",
    email: "",
    confirmEmail: "",
    school: "",
    whatsapp: "",
    age: "",
    grade: "",
    address: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setError("");
    if (
      !selectedOption ||
      !fields.fullName ||
      !fields.email ||
      !fields.confirmEmail ||
      !fields.school ||
      !fields.whatsapp ||
      !fields.age ||
      !fields.grade ||
      !fields.address
    ) {
      return;
    }
    if (fields.email !== fields.confirmEmail) {
      setError("Emails do not match.");
      return;
    }
    try {
      const ticket = generateTicket();
      const { confirmEmail, ...fieldsToSend } = fields;
      const dataToSend = {
        ...fieldsToSend,
        option: selectedOption,
        ticket,
        created: Timestamp.now()
      };
      console.log("Registering user:", dataToSend);
      await addDoc(collection(db, "registrations"), dataToSend);
      navigate("/ticket", { state: { ticket } });
    } catch (err) {
      setError("Registration failed. Please try again later.");
      console.error("Registration error:", err);
    }
  };

  return (
    <div className="register-bg">
      <div className="register-form-container">
        <h2 className="register-title">UNISFERA REGISTRATION</h2>
        <div className="register-option-row">
          <select
            value={selectedOption}
            onChange={e => setSelectedOption(e.target.value)}
            className="register-select"
            required
          >
            <option value="">Select the event you want to apply for</option>
            {options.map(opt => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
        {(!selectedOption && submitted) && (
          <div className="register-warning">
            <img src={warning} alt="warning" className="register-warning-icon" />
            <span>Please select an Event</span>
            <img src={warning} alt="warning" className="register-warning-icon" />

          </div>
        )}
        <form className="register-form" onSubmit={handleSubmit}>
          <div className="registerholder">
          <input className="input input1" type="text" name="fullName" placeholder="Full name" value={fields.fullName} onChange={handleChange} required />
          <input className="input input2" type="email" name="email" placeholder="Email" value={fields.email} onChange={handleChange} required />
          <input className="input input3" type="email" name="confirmEmail" placeholder="Confirm Email" value={fields.confirmEmail} onChange={handleChange} required />
          <input className="input input4" type="text" name="school" placeholder="School name" value={fields.school} onChange={handleChange} required />
          <input className="input input5" type="text" name="whatsapp" placeholder="Whats App contact no." value={fields.whatsapp} onChange={handleChange} required />
          <div className="register-row">
            <input className="input input6" type="number" name="age" placeholder="Age" value={fields.age} onChange={handleChange} required />
            <input className="input input7" type="text" name="grade" placeholder="Grade" value={fields.grade} onChange={handleChange} required />
          </div>
          <input className="input input8" type="text" name="address" placeholder="Residential Address" value={fields.address} onChange={handleChange} required />
          {submitted && (!fields.fullName || !fields.email || !fields.confirmEmail || !fields.school || !fields.whatsapp || !fields.age || !fields.grade || !fields.address) && (
            <div className="register-warning" style={{marginBottom: 8}}>
              <span>All fields are required.</span>
            </div>
          )}
          {error && <div className="register-warning" style={{marginBottom: 8}}>{error}</div>}
          <button type="submit" className="register-submit">SUBMIT</button>
          </div>
        </form>
      </div>
      <div className="information">
        <div className="links">
            <a href="https://www.instagram.com/unisfera_mun/"><img src={insta} alt="insta" className="image insta"></img></a>
            <a href="https://www.facebook.com/"><img src={facebook} alt="facebook" className="image facebook"></img></a>
            <a href="mailto:unisferamodelunitednations@gmail.com"><img src={mail} alt="mail" className="image mail"></img></a>     
          </div>
        <div className="copyright">© 2025 Unisfera, Inc. All Rights Reserved.</div>
      </div>
    </div>
  );
}

export default Register; 